import { push, ref, set, update } from 'firebase/database';
import { getFirebaseDb } from '@/lib/firebase';
import type { SupportNotification } from '@/types/support';

export async function pushNotification(
  uid: string,
  notification: Omit<SupportNotification, 'id' | 'createdAt' | 'read'>,
): Promise<void> {
  const nRef = push(ref(getFirebaseDb(), `notifications/${uid}`));
  await set(nRef, {
    ...notification,
    id: nRef.key,
    createdAt: Date.now(),
    read: false,
  });
}

export async function markNotificationRead(uid: string, id: string): Promise<void> {
  await update(ref(getFirebaseDb(), `notifications/${uid}/${id}`), { read: true });
}

export function requestBrowserPermission(): Promise<NotificationPermission> {
  if (typeof Notification === 'undefined') return Promise.resolve('denied');
  if (Notification.permission === 'granted') return Promise.resolve('granted');
  if (Notification.permission === 'denied') return Promise.resolve('denied');
  return Notification.requestPermission();
}

export function showBrowserNotification(title: string, body: string, tag?: string): void {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
  try {
    new Notification(title, { body, tag, silent: false });
  } catch {
    // ignore
  }
}

let audioCtx: AudioContext | null = null;

export function playNotificationSound(): void {
  try {
    const Ctx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    if (!Ctx) return;
    audioCtx ??= new Ctx();
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.type = 'sine';
    osc.frequency.value = 880;
    gain.gain.value = 0.04;
    osc.connect(gain);
    gain.connect(audioCtx.destination);
    osc.start();
    gain.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + 0.25);
    osc.stop(audioCtx.currentTime + 0.25);
  } catch {
    // ignore
  }
}
